__turbopack_context__.v({
  "closeButton": "Popin-module___JXarq__closeButton",
  "closeIcon": "Popin-module___JXarq__closeIcon",
  "content": "Popin-module___JXarq__content",
  "cta": "Popin-module___JXarq__cta",
  "message": "Popin-module___JXarq__message",
  "neutral": "Popin-module___JXarq__neutral",
  "pill": "Popin-module___JXarq__pill",
  "pillDot": "Popin-module___JXarq__pillDot",
  "pillIcon": "Popin-module___JXarq__pillIcon",
  "popin": "Popin-module___JXarq__popin",
  "positive": "Popin-module___JXarq__positive",
  "title": "Popin-module___JXarq__title",
});
